import { Package, PackageProduct } from 'types/package';
import { Product } from 'types/product';
import { ProcedurePackage } from 'types/procedure';

// Produtos avulsos do orçamento viajam como um pacote especial dentro de `packages`,
// assim total, margem, resumo e impressão os tratam como qualquer outro item.
export const LOOSE_PRODUCTS_ID = -1;

export function isLooseProducts(item: ProcedurePackage): boolean {
  return item.id === LOOSE_PRODUCTS_ID;
}

function roundMoney(value: number): number {
  return Math.round(value * 100) / 100;
}

function buildLooseProducts(products: PackageProduct[]): ProcedurePackage {
  return {
    id: LOOSE_PRODUCTS_ID,
    package_id: 0,
    priority: 1,
    package: {
      id: 0,
      name: 'Produtos avulsos',
      cost_price: 0,
      sale_price_max: 0,
      sale_price_min: 0,
      sale_price: roundMoney(products.reduce((sum, item) => sum + item.quantity * (item.unit_value || 0), 0)),
      active: true,
      supplier: null,
      supplier_id: null,
      products,
    },
  };
}

export function getLooseProducts(packages: ProcedurePackage[]): PackageProduct[] {
  return packages.find(isLooseProducts)?.package?.products || [];
}

export function setLooseProducts(packages: ProcedurePackage[], products: PackageProduct[]): ProcedurePackage[] {
  const others = packages.filter(item => !isLooseProducts(item));

  return products.length > 0 ? [...others, buildLooseProducts(products)] : others;
}

export function addLooseProduct(
  packages: ProcedurePackage[],
  product: Product,
  quantity: number,
  unitValue: number,
): ProcedurePackage[] {
  const products = [
    ...getLooseProducts(packages),
    { id: 0, product_id: product.id, quantity, unit_value: unitValue, product },
  ];

  return setLooseProducts(packages, products);
}

export function removeLooseProduct(packages: ProcedurePackage[], index: number): ProcedurePackage[] {
  return setLooseProducts(
    packages,
    getLooseProducts(packages).filter((_, position) => position !== index),
  );
}

// Pacote escolhido na hora: entra com o valor máximo sugerido, como os vinculados ao procedimento.
export function buildAddedPackage(pkg: Package): ProcedurePackage {
  return {
    id: -Date.now(),
    package_id: pkg.id,
    priority: 1,
    package: { ...pkg, sale_price: pkg.sale_price_max || 0 },
  };
}
